(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('CommunicationTopicDialogController', CommunicationTopicDialogController);

    CommunicationTopicDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'CommunicationTopic', 'CommunicationTopicCategory'];

    function CommunicationTopicDialogController ($scope, $stateParams, $uibModalInstance, entity, CommunicationTopic, CommunicationTopicCategory) {
        var vm = this;
        vm.communicationTopic = entity;
        vm.contractContacts = [
            { value: 'PHONE' },
            { value: 'EMAIL' }
        ];
        vm.load = function(id) {
            CommunicationTopic.get({id : id}, function(result) {
                vm.communicationTopic = result;
            });
        };

        vm.communicationTopicCategorys  = CommunicationTopicCategory.query();
        
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:communicationTopicUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.communicationTopic.id !== null) {
                CommunicationTopic.update(vm.communicationTopic, onSaveSuccess, onSaveError);
            } else {
                CommunicationTopic.save(vm.communicationTopic, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
